// V3 Choose Plan. Same translation category as the V2 page so the
// keys both pages share (fees, one-time / prescription-only copy, FAQ) are not duplicated.
export const CAT = "choose_plan_care_plus";

// Reused from Choose Treatment V3 so the two halves of the in-page handoff look like one flow.
export const GRADIENT = "linear-gradient(90deg, rgb(245,146,0) 0%, rgb(255,187,41) 100%)";
export const HERO_GRADIENT = "linear-gradient(180deg, #F59200 21.69%, #FFF 100%)";
export const TEXT_GRADIENT = "linear-gradient(189.45deg, #ffb909 0.80%, #e17200 94.83%)";
